// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_1u-1";
export var movingGradient = "_1u-4";
export var movingGradientBlock = "_1u-2";
export var skeleton = "_1u-0";
export var skeletonText = "_1u-3";